import script from "./printDeliver.vue?vue&type=script&setup=true&lang=js"
export * from "./printDeliver.vue?vue&type=script&setup=true&lang=js"

import "./printDeliver.vue?vue&type=style&index=0&id=25d5b796&lang=less"

const __exports__ = script;

export default __exports__